export const CONSULTANT_CARE_MSG = {
  'midnight': ['最长的路也有尽头，最黑的夜晚也会迎接清晨~', '与其窥探星星的秘密，不如成为星星一样的人~'],
  'morning': ['多年后，你一定会感激现在努力的自己~', '愿一切为之努力的事情，都有浪漫的结果~'],
  'afternoon': ['再忙也要注意身体，记得按时吃饭~', '生活中的不期而遇，都是你努力后的惊喜~'],
  'evening': ['因为喜欢，可迎万难，晚上好~', '找到目标坚持下去，生活会有礼物给你~'],
}

export const USER_CARE_MSG = {
  'midnight': ['最长的路也有尽头，最黑的夜晚也会迎接清晨~', '与其窥探星星的秘密，不如成为星星一样的人~'],
  'morning': ['多年后，你一定会感激现在努力的自己~', '愿一切为之努力的事情，都有浪漫的结果~'],
  'afternoon': ['再忙也要注意身体，记得按时吃饭~', '生活中的不期而遇，都是你努力后的惊喜~'],
  'evening': ['做颗星星，有棱有角还发光~', '知足且坚定，温柔又上进~'],
}

const DAYTIME_BGCOLOR = {
  backgroundColor:  '#B4F3FD',
  frontColor: '#000000'
}
const NIGHT_BGCOLOR = {
  backgroundColor:  '#302573',
  frontColor: '#ffffff'
}
export const NavigationBarColor = {
  'daytime': DAYTIME_BGCOLOR,
  'night': NIGHT_BGCOLOR,
}
